import axios from "axios";
import { API_URL } from "../config";

export const fetchUserProfile = async () => {
  const { data } = await axios.get(`${API_URL}/user/profile`);
  return data;
};

export const fetchCarriers = async () => {
  const { data } = await axios.get(`${API_URL}/user/carriers`);
  return data;
};

export const fetchSavedLoads = async () => {
  const { data } = await axios.get(`${API_URL}/loads/saved`);
  return Array.isArray(data) ? data : [];
};




export const searchLoads = async ({ endpoint, payload, params }) => {
  const { data } = await axios.post(endpoint, payload, { params });
  return data;
};

export const startSSESearch = async ({ payload, params }) => {
  const { data } = await axios.post(
    `${API_URL}/loads/search/start`,
    payload,
    { params }
  );
  return data;
};

export const saveLoadRequest = async (payload) => {
  await axios.post(`${API_URL}/loads/save`, payload);
};

export const deleteSavedLoadRequest = async ({ entryId }) => {
  await axios.delete(`${API_URL}/loads/${encodeURIComponent(entryId || "")}`);
};

export const bookLoadRequest = async ({ payload, params }) => {
  const { data } = await axios.post(`${API_URL}/load-book/book`, payload, {
    params,
  });
  return data;
};

export const fetchUserDocuments = async () => {
  const { data } = await axios.get(`${API_URL}/upload/files/user`);
  return Array.isArray(data) ? data : [];
};

